<script>
  // Components
  import Tooltip from './Tooltip.svelte';
  import CountiesMap from './CountiesMap.svelte';
  import CountiesTable from './CountiesTable.svelte';

  // Utils
  import { intcomma } from 'journalize';
  import { clamp } from '../utils/clamp';

  // The data
  export let data;

  // tooltip config
  let tooltipSlug = 'tooltip__counties';
  let tooltipHeader = '';
  let tooltipSubhed = '';
  let tooltipValues = [];
  let showTooltip = false;

  $: tooltipLookup = data.reduce((obj, item) => {
    obj[item.fips] = item;
    return obj;
  }, {});

  function handleMapActivateCounty(e, push = 20) {
    showTooltip = true;
    const fips = e.detail.fips;
    const data = tooltipLookup[fips];
    tooltipHeader = data.county + ' County';
    tooltipSubhed = + Math.round((data.d_change * 100)) > 0 ? `+${(data.d_change * 100).toFixed(1)} D` : `+${Math.abs((data.d_change * 100)).toFixed(1)} R`;
    tooltipValues = [
      `Davis (2002): ${(data.d_pct_02 * 100).toFixed(1)}%`,
      `Newsom (2018): ${(data.d_pct_18 * 100).toFixed(1)}%`,
    ];
    const el = document.getElementById(tooltipSlug);
    const { width, height } = el.getBoundingClientRect();
    const innerWidth = window.innerWidth;
    const innerHeight = window.innerHeight;
    const x = event.clientX;
    const y = event.clientY;
    const left = clamp(x - width / 2, push, innerWidth - width - push);
    const top =
      innerHeight > y + push * 2 + height ? y + push : y - height - push;
    el.style.left = `${left}px`;
    el.style.top = `${top}px`;
  }

  function handleMapDeactivateCounty(e) {
    showTooltip = false;
  }
</script>

<div class="svg-container svg-container__california-counties">
  <div id="d3-map-california-counties">
    <CountiesMap
      bind:data
      on:mapActivateCounty={handleMapActivateCounty}
      on:mapDeactivateCounty={handleMapDeactivateCounty}
    />
    <CountiesTable
      bind:data
    />
    <Tooltip
    slug={tooltipSlug}
    bind:showTooltip
    bind:header={tooltipHeader}
    bind:subhead={tooltipSubhed}
    bind:values={tooltipValues}
  />
  </div>
</div>
